const EXCISE_RATE = 0.02041;

export function calculateTotals(lineItems) {
  const subtotal = lineItems.reduce((sum, row) => {
    return sum + (parseFloat(row.qty) || 0) * (parseFloat(row.price) || 0);
  }, 0);
  const tax   = subtotal * EXCISE_RATE;
  const total = subtotal + tax;
  return { subtotal, tax, total };
}

export default function EstimateTotals({ lineItems }) {
  const { subtotal, tax, total } = calculateTotals(lineItems);

  const Row = ({ label, value, bold, large }) => (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: large ? '10px 16px' : '6px 16px',
      borderTop: large ? '2px solid rgba(139,69,19,0.15)' : '1px solid rgba(139,69,19,0.06)',
      background: large ? 'rgba(139,69,19,0.04)' : 'transparent',
    }}>
      <span style={{ fontSize: large ? '14px' : '12.5px', fontWeight: bold ? '700' : '500', color: large ? '#8B4513' : '#555' }}>
        {label}
      </span>
      <span style={{ fontSize: large ? '16px' : '13px', fontWeight: bold ? '700' : '600', color: large ? '#8B4513' : '#2b2b2b', fontFamily: 'monospace' }}>
        ${value.toFixed(2)}
      </span>
    </div>
  );

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
      <div style={{ width: '320px', background: 'white', borderRadius: '10px', border: '1px solid rgba(139,69,19,0.1)', boxShadow: '0 4px 16px rgba(139,69,19,0.07)', overflow: 'hidden' }}>
        <div style={{ padding: '10px 16px', background: 'linear-gradient(135deg, #8B4513 0%, #A0522D 100%)', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '14px' }}>🧾</span>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '13px' }}>Estimate Summary</span>
        </div>
        <Row label="Subtotal" value={subtotal} />
        <Row label={`SD Excise Tax (${(EXCISE_RATE * 100).toFixed(3)}%)`} value={tax} />
        <Row label="TOTAL ESTIMATE" value={total} bold large />
      </div>
    </div>
  );
}
